import React, { Component } from 'react';
import './style.css';
import * as Typeicon from 'react-icons/lib/ti'
export default class AccessDenied extends Component {
    render() {
        const status = sessionStorage.getItem('status')
        let user_status = '';
        if (status === '-1') {
            user_status = 'Not Subscribed'
        } else if (status === '0') {
            user_status = 'Inactive Subscriber'
        }
        return (
            <div className='acess-denied'>
                <h1><Typeicon.TiInfoOutline /><span>&nbsp;&nbsp;&nbsp;</span>Access denied</h1>
                <h2>{user_status}</h2>
            </div>


        )
    }
}


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/accessDenied/accessDenied.js